import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.array.find";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/infobulle.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/geoloc.svg';
import { mapGetters } from 'vuex';
import USE_MERCURE from '~/const/mercure';
import { FAQ } from '~/const/faq';
import navigationQuery from '~/graphql/navigation.gql';
import Banner from '~/components/specific/MainHeader/Banner.vue';
import BannerMobile from '~/components/specific/MainHeader/BannerMobile.vue';
import NavigationBar from '~/components/specific/MainHeader/NavigationBar.vue';
import LayerMobile from '~/components/specific/MainHeader/LayerMobile.vue';
import LayerFullscreenHeader from '~/components/specific/MainHeader/LayerFullscreenHeader.vue';
import focusElement from '~/helpers/a11y-helpers';

var LayerDesktop = function LayerDesktop() {
  return import(
  /* webpackChunkName: "layer-desktop" */
  './LayerDesktop.vue');
};

export default {
  name: 'MainHeader',
  components: {
    Banner: Banner,
    BannerMobile: BannerMobile,
    NavigationBar: NavigationBar,
    LayerFullscreenHeader: LayerFullscreenHeader,
    LayerMobile: LayerMobile,
    LayerDesktop: LayerDesktop
  },
  data: function data() {
    return {
      navigation: [],
      navigationServices: [],
      isMenuOpened: '',
      selectedItem: null,
      scrollPosition: 0,
      displayNavBar: false,
      enableNavTransition: false,
      lastActiveElement: null
    };
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale',
    homeUrl: 'i18n/homeUrl',
    user: 'user/me'
  }), {
    bodyClasses: function bodyClasses() {
      return this.isMenuOpened ? 'no-scroll w-100' : '';
    },
    accountUrl: function accountUrl() {
      if (this.user && USE_MERCURE(this.locale.iso)) {
        return "".concat(this.homeUrl, "/user");
      }

      if (USE_MERCURE(this.locale.iso)) {
        return "".concat(this.homeUrl, "/login");
      }

      return "".concat(this.homeUrl, "/account/dashboard");
    },
    faqUrl: function faqUrl() {
      var _this = this;

      // if (USE_MERCURE(this.locale.iso)) {
      //   return `/${this.locale.market}/${this.locale.language}/help`;
      // }
      return FAQ.find(function (e) {
        return e.language === _this.locale.iso;
      }).url;
    },
    urls: function urls() {
      return {
        cartUrl: this.buildCartUrl(this.locale),
        homeUrl: this.homeUrl,
        storeLocUrl: "".concat(this.homeUrl, "/store-locator"),
        helpUrl: this.faqUrl,
        accountUrl: this.accountUrl
      };
    }
  }),
  apollo: {
    navigation: {
      query: navigationQuery,
      variables: function variables() {
        return {
          locale: this.locale.iso
        };
      }
    },
    navigationServices: {
      query: navigationQuery,
      variables: function variables() {
        return {
          locale: this.locale.iso
        };
      }
    }
  },
  mounted: function () {
    var _mounted = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      var _this2 = this;

      var draftId, _ref, _ref$data, navigation, navigationServices;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              draftId = this.$cookies.get('NAVIGATION_PREVIEW');

              if (!draftId) {
                _context.next = 17;
                break;
              }

              if (this.$cookies.get('debugmdm')) console.log('Previewing draft', draftId);
              _context.prev = 3;
              _context.next = 6;
              return this.$apolloProvider.defaultClient.query({
                query: navigationQuery,
                variables: {
                  locale: this.locale.iso,
                  draftId: draftId
                }
              });

            case 6:
              _ref = _context.sent;
              _ref$data = _ref.data;
              navigation = _ref$data.navigation;
              navigationServices = _ref$data.navigationServices;
              this.navigation = navigation;
              this.navigationServices = navigationServices;
              _context.next = 17;
              break;

            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](3);
              console.log(_context.t0);

            case 17:
              document.addEventListener('click', this.onClickOutside);
              window.addEventListener('scroll', this.handleScroll, {
                passive: true
              });
              this.scrollPosition = window.pageYOffset;
              this.displayNavBar = !this.isMobile();
              this.$nextTick(function () {
                _this2.enableNavTransition = true;
              });

            case 22:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[3, 14]]);
    }));

    function mounted() {
      return _mounted.apply(this, arguments);
    }

    return mounted;
  }(),
  destroyed: function destroyed() {
    document.removeEventListener('click', this.onClickOutside);
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    openMenu: function openMenu(items) {
      var _this3 = this;

      this.selectedItem = items;

      if (items === 'mobile') {
        this.isMenuOpened = 'mobile';
      } else {
        this.isMenuOpened = items && this.isMenuOpened !== items.label ? items.label : '';
        this.lastActiveElement = document.activeElement;
        this.$nextTick(function () {
          return focusElement(_this3.$refs.layerFullscreen.$refs.close.$el);
        });
      }
    },
    closeMenu: function closeMenu() {
      this.isMenuOpened = '';
      this.selectedItem = null;
      this.$refs.layerMobile.close();
    },
    handleScroll: function handleScroll() {
      if (this.isMobile()) {
        this.displayNavBar = false;
        return;
      }

      var scroll = window.pageYOffset;
      this.displayNavBar = this.scrollPosition > scroll || scroll <= 1;
      this.scrollPosition = scroll;
    },
    onClickOutside: function onClickOutside(event) {
      var _this$$refs = this.$refs,
          navigationBar = _this$$refs.navigationBar,
          layerFullscreen = _this$$refs.layerFullscreen,
          bannerMobile = _this$$refs.bannerMobile,
          layerMobile = _this$$refs.layerMobile;
      if (!navigationBar || navigationBar.$el.contains(event.target) || !layerFullscreen || layerFullscreen.$el.contains(event.target) || !bannerMobile || bannerMobile.$el.contains(event.target) || !layerMobile || layerMobile.$el.contains(event.target)) return;
      this.closeMenu();
    }
  },
  head: function head() {
    return {
      bodyAttrs: {
        class: this.bodyClasses
      }
    };
  }
};